import MoveAndRotate from "./moveAndRotate";
import AnimationPlayer from "../animation/animationPlayer";

class MoveGroup extends MoveAndRotate {
    groupName;
    animateMovement;
    animateTime;

    constructor(props) {
        super(props);
        this.groupName = props.groupName;
        this.animateMovement = props.animateMovement;
        this.animateTime = props.animateTime;

    }

    async stop() {
        const group = GroupData.getGroupByName(this.groupName);
        if (!group) return;
        changePerformMoveOnGroup(true);
        AnimationPlayer.stopConflictingMeshAnimations(AnimationPlayer.meshType.GROUP, group.id);
        changePerformMoveOnGroup(false);
    }

    async execute() {
        const volumeFinalMatrix = this.getComposedMatrix();
        const group = GroupData.getGroupByName(this.groupName);
        if (!group) return;
        changePerformMoveOnGroup(true);
        AnimationPlayer.stopConflictingMeshAnimations(AnimationPlayer.meshType.GROUP, group.id);

        if (this.animateMovement === undefined) {
            this.animateMovement = true;
        }
        if (!this.animateTime) {
            this.animateTime = 2000;
        }

        moveGroup(this.groupName, volumeFinalMatrix, this.animateMovement, this.animateTime, !!this.transitionValues, false);
        changePerformMoveOnGroup(false);
    }
}

export default MoveGroup;
